var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('strong',[_vm._v("วิธีเล่นหวย")]),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body p-2"},[_vm._v("Dashboard")])])])}]

export { render, staticRenderFns }